import { RouteInstanceItem } from '../../../../../../pages/admin-dashboard/admin-route-instance-management/route-instances.model';
import { RouteInstanceTableRow } from './route-instance-table.model';

function toRouteInstanceTableRow(instance: RouteInstanceItem, index: number, isArabic: boolean): RouteInstanceTableRow {
  const city = isArabic ? instance.city?.titleAr : instance.city?.titleEn;
  const governorate = isArabic ? instance.governorate?.titleAr : instance.governorate?.titleEn;

  return {
    id: instance.id,
    index: index + 1,
    routeName: instance.routeName,
    cityGovernorate: city && governorate ? `${city} - ${governorate}` : (city ?? governorate ?? '—'),
    ordersCount: instance.ordersCount,
    pharmaciesCount: instance.pharmaciesCount,
    distributor: instance.distributor?.fullName ?? (isArabic ? 'لم يتم التعيين' : 'Not Assigned'),
    hasDistributor: !!instance.distributor,
    createdOn: instance.createdOn,
    createdBy: instance.createdBy?.fullName ?? '—',
    lastModifiedOn: instance.lastModifiedOn ?? null,
    lastModifiedBy: instance.lastModifiedBy?.fullName ?? null,
    dispatchTime: instance.dispatchTime?.timeFrom ?? '—',
    status: {
      titleEn: instance.status?.titleEn ?? '—',
      titleAr: instance.status?.titleAr ?? '—',
    },
  };
}

export function toRouteInstanceTableRows(instances: RouteInstanceItem[], isArabic: boolean): RouteInstanceTableRow[] {
  return instances.map((r, i) => toRouteInstanceTableRow(r, i, isArabic));
}
